export default "__VITE_ASSET__DuY6dhxt__"